export const EMAIL_VERIFICATION_TYPE = "EMAIL";
export const EREG_VERIFICATION_TYPE = "EREG";

export const FILE_UPLOAD_LIMIT = {
    extension: [
        "trustvc", "vc2", "json"
    ],
    maxLength: 100,
    maxSize: 20 //MB
}